import script from "./SummaryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryComponent.vue?vue&type=script&setup=true&lang=js"

import "./SummaryComponent.vue?vue&type=style&index=0&id=131c7385&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-131c7385"]])

export default __exports__